import { Typography } from '@mui/material';
import { ToolbarButton } from '@mui/x-data-grid';
import { ExportCsv } from '@mui/x-data-grid';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useTranslation } from 'react-i18next';
import './GridExport.css';

export default function GridExport({ filename, isListView }: { filename: string; isListView: boolean }) {
  const { t } = useTranslation();
  return (
    <ExportCsv
      className="export_button"
      data-qa-element-id="export_button"
      render={<ToolbarButton />}
      options={{
        allColumns: true,
        includeHeaders: true,
        utf8WithBom: true,
        fileName: filename,
      }}
    >
      <FileDownloadIcon fontSize="small" color="primary" />
      {!isListView && (
        <>
          &nbsp;<Typography variant="button">{t('export')}</Typography>
        </>
      )}
    </ExportCsv>
  );
}
